import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';
import FindSparePartPageViewModel = Vertica.LouisPoulsen.Application.Content.Pages.CategoryPage.FindSparePartPageViewModel;
import SparePartProductViewObject = Vertica.LouisPoulsen.Application.Content.Pages.CategoryPage.SparePartProductViewObject;
import SparePartTile from './SparePartTile.vue';
import SparePartCategoryViewObject = Vertica.LouisPoulsen.Application.Content.Pages.CategoryPage.SparePartCategoryViewObject;


export default /*#__PURE__*/_defineComponent({
  __name: 'SparePartsCategoryListProfessional',
  props: {
    model: null
  },
  emits: ["ear"],
  setup(__props: any, { emit }: { emit: ({(e: 'ear', value: number): void}), expose: any, slots: any, attrs: any }) {

const props = __props as {model: FindSparePartPageViewModel}




onMounted(updateEar);

const selectedCategoryIds = ref<string[]>([]);

const selectableCategories = computed<SparePartCategoryViewObject[]>(() => {
    return props.model.categories.filter(category => category.id !== 'n/a');
});
const filteredProducts = computed<SparePartProductViewObject[]>(() => {
    if (selectedCategoryIds.value.length >= 1) {
        return props.model.products.filter(product => selectedCategoryIds.value.indexOf(product.categoryId) >= 0);
    }
    return props.model.products;
});

function updateEar() {
    emit('ear', filteredProducts.value.length);
}

return { __sfc: true,props, emit, selectedCategoryIds, selectableCategories, filteredProducts, updateEar, SparePartTile }
}

})